import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetUserGroupsQuery } from '../../../api';

/**
 * Eğitmen atama sekmesi için tekli kullanıcı seçim dropdown'u.
 * `src/components/common/UserDropdown.jsx` ile aynı veri kaynağını (useGetUserGroupsQuery)
 * kullanır; o bileşen çoklu seçim (MultiSelect) için tasarlandığından, eğitmen atama ucu
 * tek bir `userId` beklediği için (bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §4.2)
 * burada ayrı, tekli seçim (Dropdown) bir bileşen kullanılıyor.
 */
const InstructorUserDropdown = ({ value, onChange, excludeUserIds = [], placeholder, disabled = false, className = '' }) => {
    const { data: userGroupsResponse, isLoading } = useGetUserGroupsQuery();

    const options = useMemo(() => {
        const users = userGroupsResponse?.data || [];
        return users.filter((user) => !excludeUserIds.includes(user.id)).map((user) => ({ id: user.id, name: user.name, displayValue: `${user.id} - ${user.name}` }));
    }, [userGroupsResponse?.data, excludeUserIds]);

    return (
        <Dropdown
            value={value ?? null}
            options={options}
            optionLabel="displayValue"
            optionValue="id"
            onChange={(e) => onChange(e.value)}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            filter
            showClear
            filterBy="id,name"
            className={className}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default InstructorUserDropdown;
